import { t } from "@lingui/macro";
import * as React from "react";
import { Path } from "react-native-svg";

import { Icon, IconProps } from "../../../primitive";

export const ArrowRightIcon = (props: IconProps) => (
  <Icon viewBox="0 0 16 16" fill="none" title={t`Arrow Right`} {...props}>
    <Path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m9 14 6-6-6-6M1 8h13"
      fill="none"
    />
  </Icon>
);
